import { useEffect, useState } from "react";

const usePageVisibility = () => {

  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const eventHandler = () => {
      if (document.visibilityState === "visible") {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }
    document.addEventListener("visibilitychange", eventHandler)

    return () => {
      document.removeEventListener("visibilitychange", eventHandler)
    }
  }, [])

  return isVisible

}

export default usePageVisibility
